/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Row, Col, Container, Button } from "react-bootstrap";
import translations from "../../utilities/translations";
import { useAuth } from "../../context/AuthContext";
import phone from "../../images/phone-footer.svg";
import mail from "../../images/mail-footer.svg";

import "../../styles/components/_footer.scss";

const Footer = ({ footerMenu }) => {
  const { footerMenuItems } = footerMenu;
  const { handleLogout, handleLogin, user, currentLanguage } = useAuth();
  const [buttonHref, setButtonHref] = useState("/syndesi-eggrafi/");
  const [buttonText, setButtonText] = useState(
    translations("login-register", currentLanguage)
  );

  const footerMenuArray = Array.isArray(footerMenu.footerMenu)
    ? footerMenu.footerMenu
    : [];

  const mainArray = footerMenuArray.filter(
    (item) => item.strapi_component === "settings.main"
  );

  const contactInfo = footerMenuArray.filter(
    (item) => item.strapi_component === "settings.contact-info"
  );

  const socialMedia = footerMenuArray.filter(
    (item) => item.strapi_component === "settings.social"
  );

  useEffect(() => {
    if (user === null) {
      setButtonHref("/syndesi-eggrafi/");
      setButtonText(translations("login-register", currentLanguage));
    } else {
      setButtonHref("/");
      setButtonText(translations("logout", currentLanguage));
    }
  }, [user, currentLanguage]);

  return (
    <footer className="footer">
      <Container className="max-container">
        <Row className="justify-content-center">
          <Col md={4} className="text-center text-md-left  mb-5 mb-md-0">
            <img
              src={mainArray[0]?.logo?.localFile?.publicURL}
              className="footer-logo"
              alt="xerolivado logo"
            />
          </Col>
          <Col md={8} className="text-center text-md-left">
            <p>{contactInfo[0]?.title}</p>
            <div className="mb-3 d-none d-md-flex align-items-center">
              {contactInfo[0].contactInfo?.map((item, index) => (
                <React.Fragment key={index}>
                  <>
                    {index === 0 && (
                      <img
                        src={phone}
                        alt="phone icon"
                        className="me-2"
                        style={{ height: "14px" }}
                      />
                    )}
                    <a href={item?.phoneUrl} className="me-2">
                      {item?.phone}
                    </a>
                    {index === 0 && <span className="me-2">|</span>}
                  </>

                  {item.email && (
                    <>
                      <img
                        src={mail}
                        alt="mail icon"
                        className="me-2 ms-3"
                        style={{ height: "14px" }}
                      />
                      <a href={item?.emailUrl} className="me-3">
                        {item?.email}
                      </a>
                    </>
                  )}
                </React.Fragment>
              ))}
            </div>
            <Row className="d-flex d-md-none mb-3 contact-m justify-content-center">
              {contactInfo[0].contactInfo?.map((item, index) => (
                <React.Fragment key={index}>
                  <Col
                    className={`col-5 mb-2 p-0 ${
                      index === 1 ? "text-left" : ""
                    }`}
                  >
                    {index === 1 && <span className="me-2">|</span>}
                    {index === 0 && (
                      <img
                        src={phone}
                        alt="phone icon"
                        className="me-2"
                        style={{ height: "14px" }}
                      />
                    )}
                    <a href={item?.phoneUrl} className="me-0">
                      {item?.phone}
                    </a>
                  </Col>

                  {item.email && (
                    <Col className="col-12">
                      <img
                        src={mail}
                        alt="mail icon"
                        className="me-2"
                        style={{ height: "14px" }}
                      />
                      <a href={item?.emailUrl} className="me-3">
                        {item?.email}
                      </a>
                    </Col>
                  )}
                </React.Fragment>
              ))}
            </Row>
            <div className="d-flex mb-3 justify-content-center justify-content-md-start">
              {socialMedia?.map((item, index) => (
                <div key={index}>
                  <a
                    href={item?.link}
                    className="mx-2 mx-md-0"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={item?.icon?.localFile?.publicURL}
                      alt="mail icon"
                      className="me-md-3"
                    />
                  </a>
                </div>
              ))}
            </div>

            <Button
              className="my-4 my-md-2 px-4 text-dark btn-footer"
              variant="light"
              href={buttonHref}
              onClick={user !== null ? handleLogout : handleLogin}
            >
              {buttonText}
            </Button>
            <hr className="hr" />
            <div className="menu">
              {footerMenuItems.map((item, index) => {
                return (
                  <a
                    href={item.page?.slug}
                    className="me-1 me-md-5 p-2 ps-0"
                    key={index}
                  >
                    {item.menuItem}
                  </a>
                );
              })}
            </div>
          </Col>
        </Row>
        <Row>
          <div className="copyrights mt-4">
            <h6>
              Copyright © 2023 ELATA XIROLIVADOU | All Rights Reserved Web
              Design & Development by{" "}
              <a
                className="text-white hover:underline"
                href="https://think-plus.gr/"
                target="_blank"
                rel="noreferrer"
              >
                Τhink Plus
              </a>
            </h6>
          </div>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
